import type { PropsWithChildren, ReactNode } from 'react';

type CouponToolboxProps = PropsWithChildren;

/**
 * Renders the coupontoolbox a section parent, should be combined with header, content and buttons as needed.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @returns section wrapper.
 */
export default function CouponToolbox({ children }: CouponToolboxProps): ReactNode {
  return <section>{children}</section>;
}
